export default "__VITE_ASSET__DnmGSXmF__"